/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/* @flow */
const MAX_STACK_LENGTH: number = 50;

export function registerStackTraceLimit(limit: number = MAX_STACK_LENGTH) {
  try {
    Error.stackTraceLimit = limit;
  } catch (e) {
    // Not all browsers support this so we don't care if it errors
  }
}
